/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'

export const blind_gift_homepage = createAsyncThunk(
  'BlindBoxGift/blind_gift_homepage',
  async (p: any, store: any) => {
    const resp = await http.post('/live/gift/blind_gift_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export const blind_rank = createAsyncThunk(
  'BlindBoxGift/blind_rank',
  async (param: {week_offset: number; tab: number}, store: any) => {
    const resp = await http.post('/live/gift/blind_rank', {
      ...store.getState().env.deviceinfo,
      ...param,
    })
    return resp.data.data
  }
)

interface user_info {
  rank: number
  score: number
  blind_list?: Array<{
    gift_id?: number
    icon?: string
  }>
  member?: any
}
const initialState: {
  home: {
    critical_list?: Array<{
      mid: number
      avatar: string
      coin: number
      name: string
      cnt: number
    }>
    broad_list?: Array<{
      mid: number
      avatar: string
      coin: number
      name: string
      cnt: number
    }>
    list?: Array<{
      gift_list: Array<{
        gift_id: number
        icon: string
        coin: number
        name: string
        blind_level: number
        probability: number
      }>
      blind_gift?: {
        gift_id: number
        icon: string
        coin: number
        name: string
      }
    }>
  }
  rank: {
    list?: Array<user_info>
    own?: user_info
    reward_num?: number
    reward_icon?: string
    count_down?: number
    reelection_cnt?: number
    last_member?: any
  }
} = {
  home: {},
  rank: {},
}

export const BlindBoxGiftSlice = createSlice({
  name: 'BlindBoxGift',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(blind_gift_homepage.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload})
    })
    builder.addCase(blind_rank.fulfilled, (state, action) => {
      Object.assign(state, {rank: action.payload})
    })
  },
})

export const useBlindBoxGift = () => useSelector((store) => store.BlindBoxGift)

export default BlindBoxGiftSlice.reducer
export const BlindBoxGiftActions = BlindBoxGiftSlice.actions
